import { render, staticRenderFns } from "./gOption.vue?vue&type=template&id=95cf3bb0&"
import script from "./gOption.vue?vue&type=script&lang=js&"
export * from "./gOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gOption.vue"
export default component.exports